import { aiUseCasesData } from "@/mocks/aiSolutionsData";
import AnimatedSection from "@/components/AnimatedSection";

export default function AiUseCasesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-astro">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3 font-heading tracking-tight">
              {aiUseCasesData.heading}
            </h2>
            <div className="w-16 h-1 rounded-full mx-auto bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316]" />
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              {aiUseCasesData.subtext}
            </p>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {aiUseCasesData.items.map((item, i) => (
            <AnimatedSection key={item.title} delay={i * 80}>
              <div className="h-full flex flex-col rounded-2xl border border-background-200/80 bg-background-100 p-6 card-lift hover:border-accent-200">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#2563EB] to-[#7C3AED] text-background-50 flex items-center justify-center">
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${item.icon} text-xl`} />
                    </span>
                  </div>
                  <span className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-[11px] font-semibold">
                    {item.industry}
                  </span>
                </div>
                <h3 className="text-base font-bold text-foreground-950 font-heading mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}